import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";
import { SITE } from "../data/site";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (user) nav("/admin");
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Signed in.");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <img src={SITE.logo} alt="USA Limo Service" className="h-16 w-16 object-contain mb-4" />
          <div className="label-eyebrow text-[#d4af6a]">USA Limo Service · Admin</div>
          <h1 className="font-display text-3xl text-white mt-2">Sign in to dashboard</h1>
        </div>
        <form onSubmit={submit} className="bg-[#0c0c0c] border border-white/10 p-8" data-testid="admin-login-form">
          <label className="block text-xs uppercase tracking-widest text-white/50 mb-1.5">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="lux-input mb-4"
            placeholder="info@usalimoservice.com"
            data-testid="admin-email"
          />
          <label className="block text-xs uppercase tracking-widest text-white/50 mb-1.5">Password</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="lux-input mb-6"
            data-testid="admin-password"
          />
          <button type="submit" disabled={loading} className="btn-accent w-full justify-center" data-testid="admin-login-submit">
            {loading ? <Loader2 className="animate-spin" size={16} /> : <Lock size={14} />}
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
